module.exports = __webpack_public_path__ + "static/img/home_new_center.968ca4ca.png";